module.exports = __webpack_public_path__ + "img/sem_2.af440e3f.png";